{
  "name": "escape_server",
  "displayName": "Escape Server",
  "version": "3.21.0",
  "author": "coqsenpate",
  "license": "UNLICENSED",
  "repository": {
    "type": "git",
    "url": "git@bitbucket.org:coqsenpate/pandore-escape_server.git"
  },
  "scripts": {
    "start": "node server",
    "preinstall": "check-node-version --node \"$(< .nvmrc)\""
  },
  "devDependencies": {
    "@types/adm-zip": "^0.5.8",
    "@types/bcrypt": "^6.0.0",
    "@types/better-sqlite3": "^7.6.13",
    "@types/busboy": "^1.5.4",
    "@types/express-session": "^1.19.0",
    "@types/lodash": "^4.17.24",
    "@types/mysql": "^2.15.27",
    "@types/socket.io-client": "^3.0.0",
    "@types/zip-stream": "^7.0.0",
    "backbone": "^1.6.1",
    "backbone.marionette": "^4.1.3",
    "backbone.stickit": "^0.9.2",
    "bootstrap": "^4.6.2",
    "connect-livereload": "^0.6.1",
    "esbuild": "^0.28.1",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-handlebars": "^1.0.3",
    "esbuild-sass-plugin": "^3.7.0",
    "filesize": "^11.0.22",
    "fontawesome-pro": "github:happinov/fontawesome-pro-6.7.2",
    "grunt": "^1.6.3",
    "grunt-contrib-clean": "^2.0.1",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-symlink": "^1.0.0",
    "grunt-contrib-watch": "^1.1.0",
    "grunt-esbuild": "^1.0.1",
    "grunt-express-server": "^0.5.4",
    "grunt-newer": "^1.3.0",
    "grunt-open": "^0.2.4",
    "grunt-replace": "^2.0.2",
    "grunt-shell": "^4.0.0",
    "handlebars": "^4.7.9",
    "jquery": "^3.7.1",
    "js-datepicker": "^5.18.4",
    "load-grunt-tasks": "^5.1.0",
    "path-browserify": "^1.0.1",
    "popper.js": "^1.16.1",
    "socket.io-client": "^4.8.3",
    "sprintf-js": "^1.1.3",
    "sweetalert2": "^11.26.25",
    "time-grunt": "^2.0.0",
    "toastr": "^2.1.4",
    "typescript": "^5.9.3"
  },
  "dependencies": {
    "@somesmall.studio/rtpmidi": "github:coqsenpate/node-rtpmidi#custom",
    "@types/debug": "^4.1.13",
    "adm-zip": "^0.6.0",
    "ajv": "^8.20.0",
    "argon2": "^0.45.1",
    "bcrypt": "^6.0.0",
    "better-sqlite3": "^13.0.1",
    "busboy": "^1.6.0",
    "check-disk-space": "^3.4.0",
    "cors": "^2.8.6",
    "cron": "^4.4.0",
    "debug": "^4.4.3",
    "express": "^5.2.1",
    "express-session": "^1.19.0",
    "extract-zip": "^2.0.1",
    "happi-helpers": "github:happinov/happi-helpers#1.2.1",
    "ky": "^2.0.2",
    "lodash": "^4.18.1",
    "log4js": "^6.9.1",
    "mdns2025": "^1.0.0",
    "mime": "^4.1.0",
    "moment": "^2.30.1",
    "mv": "^2.1.1",
    "mysql": "^2.18.1",
    "project-name-generator": "^2.1.9",
    "semver": "^7.8.5",
    "socket.io": "^4.8.3",
    "yauzl": "^3.4.0",
    "zip-stream": "^7.0.5"
  }
}
